var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCircularCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 9.99806C17.668 5.76423 14.2358 2.33203 10.002 2.33203C5.76813 2.33203 2.33594 5.76423 2.33594 9.99806C2.33594 14.2319 5.76813 17.6641 10.002 17.6641C14.2358 17.6641 17.668 14.2319 17.668 9.99806Z",
    fill: "#FCFDFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 13.4323C18.4581 9.80505 17.0543 5.3279 13.4271 3.4323C9.79984 1.53669 5.32268 2.94046 3.42708 6.5677C1.53147 10.1949 2.93524 14.6721 6.56248 16.5677C10.1897 18.4633 14.6669 17.0595 16.5625 13.4323Z",
    stroke: "#E4E7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2654 9.99942L11.7475 8.51732C11.7835 8.48188 11.804 8.43356 11.8044 8.383C11.8049 8.33245 11.7852 8.28379 11.7498 8.24773C11.7143 8.21168 11.666 8.19118 11.6154 8.19075C11.5649 8.19032 11.5162 8.20999 11.4802 8.24543L9.99807 9.72753L8.51086 8.24543C8.49347 8.22646 8.47243 8.2112 8.44899 8.20058C8.42555 8.18996 8.4002 8.1842 8.37447 8.18364C8.34875 8.18308 8.32317 8.18773 8.29929 8.19732C8.27541 8.20691 8.25372 8.22123 8.23552 8.23943C8.21732 8.25762 8.203 8.27932 8.19341 8.3032C8.18383 8.32708 8.17917 8.35265 8.17973 8.37838C8.18029 8.40411 8.18606 8.42945 8.19668 8.45289C8.2073 8.47633 8.22255 8.49738 8.24153 8.51477L9.72363 9.99686L8.24153 11.479C8.20834 11.5152 8.19042 11.5628 8.19149 11.6119C8.19256 11.661 8.21254 11.7078 8.24728 11.7425C8.28201 11.7773 8.32881 11.7973 8.37791 11.7983C8.42702 11.7994 8.47465 11.7815 8.51086 11.7483L9.99296 10.2662L11.4751 11.7483C11.5113 11.7815 11.5589 11.7994 11.608 11.7983C11.6571 11.7973 11.7039 11.7773 11.7386 11.7425C11.7734 11.7078 11.7934 11.661 11.7944 11.6119C11.7955 11.5628 11.7776 11.5152 11.7444 11.479L10.2654 9.99942Z",
    fill: "#2F394E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCross);
export default __webpack_public_path__ + "static/media/circularCross.0a410834.svg";
export { ForwardRef as ReactComponent };